import { useMutation } from "@1f/react-sdk";
import { mutation_add_metering_consumption } from "../mutations/meteringMutations";

export const MeteringApi = () => {
    const apiAddMeteringConsumption = useMutation(
        mutation_add_metering_consumption,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    
    const AddMeteringConsumption = async (azienda,tenantId) => {
        try {
            let addingMeteringResponse = await apiAddMeteringConsumption.fetch({
                tenantId: tenantId,
                companyName: azienda.denominazione,
                companyId: azienda.id,
            })
            if(addingMeteringResponse){
                return addingMeteringResponse.data.data.addMeteringConsumption
            }
        } catch (error) {
            throw new Error("Impossibile aggiungere il consumo al metering per l'azienda " + azienda.denominazione + ": " + error.message)
        }
    }

    return {
        AddMeteringConsumption
    }
}